import { Goal, GoalTreeIndex, ID } from '@griply/types';

export const createGoalTreeIndex = <TGoal extends Goal>(
  goals: TGoal[],
): GoalTreeIndex<TGoal> => {
  const goalById = new Map<ID, TGoal>();
  const childrenByParentId = new Map<ID, TGoal[]>();

  goals.forEach((goal) => {
    // `.find()` returns the first match, so a duplicate id must not overwrite.
    if (!goalById.has(goal.id)) {
      goalById.set(goal.id, goal);
    }

    if (!goal.parentIds?.length) {
      return;
    }
    const parentId = goal.parentIds[goal.parentIds.length - 1];
    const existing = childrenByParentId.get(parentId);
    if (existing) {
      existing.push(goal);
      return;
    }
    childrenByParentId.set(parentId, [goal]);
  });

  return {
    goalById,
    childrenByParentId,
    completionByGoalId: new Map(),
    colorByLinkedId: new Map(),
  };
};
